<script lang="ts">
  // Note: this should ideally be a snippet inside of ProductLanding.svelte whenever we migrate to Svelte 5.

  import { m } from "$lib/paraglide/messages";
  import { periodOptions, type Price } from "$lib/products";
  import { getFormattedPrice } from "$lib/utils";
  import Label from "@brave/leo/src/components/label/label.svelte";
  import DOMPurify from "isomorphic-dompurify";

  export let option: Price;
  export let isSolo = false;

  $: showSuffix = option.period !== "one-off";

  $: dirtySuffixText =
    periodOptions.get(option.period).promoSuffix?.({ annualPrice: getFormattedPrice(option.price) }) ||
    periodOptions.get(option.period).suffix;
</script>

<div class="col-[3] flex flex-wrap items-center gap-x-m">
  <div class:text-heading-h4={isSolo} class:text-text-primary={isSolo} class="shrink-0 whitespace-nowrap">
    {periodOptions.get(option.period).description}
  </div>
  {#if option.period === "year"}
    <span class="shrink-0">
      <Label color="green">{m.best_value_label()}</Label>
    </span>
  {/if}
</div>

<div
  class="text-heading-h2 col-[5] flex flex-wrap items-center gap-x-m text-text-primary"
  class:justify-end={!showSuffix}
>
  <span class="shrink-0">{getFormattedPrice(option.period === "year" ? option.price / 12 : option.price)}</span>
  {#if showSuffix}
    <span class="text-default-regular inline-flex flex-wrap gap-x-s text-text-tertiary">
      {@html DOMPurify.sanitize(dirtySuffixText, { ALLOWED_TAGS: ["span"], RETURN_TRUSTED_TYPE: true })}
    </span>
  {/if}
</div>
